'use client';

import {styled} from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";

const SearchInput = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
        padding: theme.spacing(.5, .5, .5, 0),
        paddingLeft: `calc(1em + ${theme.spacing(1.5)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        maxWidth: '300px'
    },
}));

export default SearchInput;
